import client from '@/services/';

const state = () => ({
    all: [],
    one: {}
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAll(cxt, payload) {
        let { data } = await client.get('naturePiece');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP(cxt, payload = {}) {
        let { data } = await client.get('naturePiece/' + payload);
        cxt.commit("SET_ALL", {
            loaded: true, ...data, number: data.number + 1,
            content: data.content || []
        })
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let { data } = await client.get('naturePiece/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('naturePiece/edit/' + payload.id, payload) : await client.post('naturePiece/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('naturePiece/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async requeteNature(cxt, payload = { page: 1, naturePieceId: '' }) {
        let { data } = await client.get(`/fichier/naturePiece/${payload.page}/${payload.naturePieceId}`, { params: { page: payload.page, naturePieceId: payload.naturePieceId } });
        return data;
    },
    async exportRequeteNature(cxt, payload = { naturePieceId: '' }) {
        let response = await client.get(`/fichier/naturePiece/export/${payload.naturePieceId}`);
        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
